import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getFillInTheBlanks = (params) => {
	var url = ApiRouters.FILLINTHEBLANKS;
	return api.get(url, { params });
};

export const getFillInTheBlanksDetail = (id, params) => {
	var url = `${ApiRouters.FILLINTHEBLANKS}/${id}`;
	return api.get(url, { params });
};

export const createQuesFillInTheBlanks = (body) => {
	var url = ApiRouters.FILLINTHEBLANKS;
	return api.post(url, body);
};

export const updateFillInTheBlanksDetail = (body) => {
	var url = `${ApiRouters.FILLINTHEBLANKS}/${body.id}`;
	return api.put(url, body.model);
};

export const deleteFillInTheBlanks = (id) => {
	var url = `${ApiRouters.FILLINTHEBLANKS}/${id}`;
	return api.delete(url);
};
